// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"b43a0e16","540":"4e8f4a24","587":"a9583a24","603":"ea7e40f9","781":"1519b241","961":"2dfe49cb"}[chunkId] + ".chunk.js";
};